import { render, staticRenderFns } from "./selectHSentences.vue?vue&type=template&id=18a346c1"
import script from "./selectHSentences.vue?vue&type=script&lang=js"
export * from "./selectHSentences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports